import { FC } from "react";

import { FormType } from "@simplyk/common";

import { useSalesOpenSchedule } from "../SalesOpeningChip/useSalesOpenSchedule";

import { useFormV2Context } from "@/canvas/features/FormV2/contexts/FormV2Context";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { GHOST_PREVIEW_OPACITY } from "@/features/LiveFormEditor/LivePreview/ghostPreview.constant";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { useIsGhostPreview } from "@/features/LiveFormEditor/LivePreview/useIsGhostPreview";
// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { FORM_ELEMENT_IDS } from "@/features/LiveFormEditor/Steps/helpers/formStepToElementIdMap";
import { FormDateRangeWithScarcity, FormDateRangeWithScarcityProps } from "@/forms-design-system/FormDate";

type CampaignDateProps = Omit<FormDateRangeWithScarcityProps, "startDate" | "endDate" | "timezone">;

export const CampaignDate: FC<CampaignDateProps> = ({ sx, ...rest }) => {
  const { hasDate } = useFormV2Context(FormType.Ticketing);
  const {
    selectedOccurrenceWithRates,
    occurrencesWithRates,
    formObject: ticketing,
  } = useFormV2Context(FormType.Ticketing);
  const isDateGhostPreview = useIsGhostPreview("TicketingV2DateSummary");
  const { isSalesScheduled } = useSalesOpenSchedule();

  const startDate = selectedOccurrenceWithRates?.occurrence?.startUtc;
  const endDate = selectedOccurrenceWithRates?.occurrence?.endUtc;
  const hasMultipleOccurrences = occurrencesWithRates.length > 1;

  if (!hasDate || !startDate || !endDate || hasMultipleOccurrences) {
    return null;
  }

  const opacity = isDateGhostPreview ? GHOST_PREVIEW_OPACITY : isSalesScheduled ? 0.4 : 1;

  return (
    <FormDateRangeWithScarcity
      startDate={new Date(startDate)}
      endDate={new Date(endDate)}
      timezone={ticketing?.eventTimezone ?? null}
      data-test="ticketing-date"
      id={FORM_ELEMENT_IDS["date"]}
      sx={{ opacity, ...sx }}
      {...rest}
    />
  );
};
